import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";
import { Nest } from "../../events-screen/event-page-models/noal.models";
import { BrotherAttributionService } from "../../../_services/brother-attribution.service";

import { fromPromise } from "rxjs/observable/fromPromise";
import { FamilyModel } from "../brother-attribution-models/family-model";
import { ChildModal } from "../../../child";
import { ITranslations } from "../../../_models/ITranslations";
import { TranslationService } from "../../../_services/translation.service";

export interface ChildObject {
  id: number;
  firstName: string;
  lastName: string;
  layer: string;
  nest: string;
  address: string;
  israeliId: string;
  isChosen: boolean;
}

@Component({
  selector: "brother-attribution-child-selector",
  templateUrl: "./brother-attribution-child-selector.component.html",
  styleUrls: [
    "brother-attribution-child-selector.component.scss",
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
  ],
})
export class BrotherAttributionChildSelector
  implements OnInit, OnDestroy, AfterViewInit
{
  public allNests: Nest[];

  public selectedFamilies: FamilyModel[] = [
    {
      members: [
        {
          id: 100,
          firstName: "איתמר",
          lastName: "ריין",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ט'",
        },
        {
          id: 101,
          firstName: "יוסי",
          lastName: "ריין",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ד'",
        },
      ],
    },
    {
      members: [
        {
          id: 5108,
          firstName: "אברהם",
          lastName: "כהן",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ט'",
        },
        {
          id: 16523464,
          firstName: "שרה",
          lastName: "כהן",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ד'",
        },
        {
          id: 165422364,
          firstName: "יעקוב",
          lastName: "כהן",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ד'",
        },
      ],
    },
    {
      members: [
        {
          id: 1423408,
          firstName: "אבי",
          lastName: "הרוש",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ט'",
        },
        {
          id: 165423464,
          firstName: "נוני",
          lastName: "הרוש",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ד'",
        },
        {
          id: 165642344,
          firstName: "לימור",
          lastName: "הרוש",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ד'",
        },
      ],
    },
    {
      members: [
        {
          id: 1620453200,
          firstName: "חן",
          lastName: "פלג",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ט'",
        },
        {
          id: 1064503261,
          firstName: "אור",
          lastName: "פלג",
          israeliId: "a7***100",
          address: "",
          nest: "רמתיים",
          layer: "ד'",
        },
      ],
    },
  ];
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput")
  public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;

  @Output("updateFamilyStatus") public updateNewFamilyStatus: EventEmitter<
    FamilyModel[]
  > = new EventEmitter<FamilyModel[]>();
  protected readonly ChildModal = ChildModal;

  constructor(
    private modalService: NgbModal,
    private brotherAttributionService: BrotherAttributionService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.brotherAttributionService.searchChildAndSiblingsByText("אבי").then();
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(this.addIsChosenPropertyToChildren(term));
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.autoCompleteInput.nativeElement.value = "";
    const organSelected = $event.item as ChildObject;
    this.selectedFamilies.push({ members: [organSelected] });
    this.updateFamilyStatus();
  }

  public removeFamily($event, familyToRemove: FamilyModel) {
    const familyObj = this.selectedFamilies.find((f) => {
      return f.members.every(
        (member) =>
          !!familyToRemove.members.find(
            (memberToRemove) => memberToRemove.id === member.id
          )
      );
    });
    if (!familyObj) {
      return;
    }
    this.selectedFamilies.splice(this.selectedFamilies.indexOf(familyObj), 1);

    this.updateFamilyStatus();
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  private async addIsChosenPropertyToChildren(
    term: string
  ): Promise<ChildObject[]> {
    const children =
      await this.brotherAttributionService.searchChildAndSiblingsByText(term);
    const allChildrenIds = new Set(
      this.selectedFamilies
        .map((f) => f.members)
        .reduce((acc, family) => {
          return acc.concat(family);
        }, [])
        .map((child) => child.id)
    );

    return children.map((child) => {
      return {
        ...child,
        isChosen: allChildrenIds.has(child.id),
      };
    });
  }

  private updateFamilyStatus() {
    this.updateNewFamilyStatus.emit(this.selectedFamilies);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-child-selector/brother-attribution-child-selector.component.ts